import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserStore } from 'src/app/core/stores/user.store';
import { buildSignInQueryParams } from 'src/app/core/utils/auth/return-url.utils';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  userStore = inject(UserStore);
  router = inject(Router);

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.userStore.isAuthorized()) {
      return true;
    }

    return this.router.createUrlTree(['/auth/sign-in'], { queryParams: buildSignInQueryParams(state.url) });
  }
}
